import { useState } from "react";
import { client } from "../../sanityClient";
import "./NewUserForm.css";

export default function NewUserForm({ onClose, onUserCreated, showToast }) {
    const [newUser, setNewUser] = useState({
        username: "",
        contactNumber: "",
        remarks: "",
        imageFile: null,
    });
    const [loading, setLoading] = useState(false);

    const generateTimestampID = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const ms = now.getMilliseconds().toString().padStart(3, "0");
        return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${ms}`;
    };

    const handleCreateUser = async (e) => {
        e.preventDefault();
        if (!newUser.username || !newUser.contactNumber) {
            showToast("error", "Please fill Name and Contact Number");
            return;
        }

        setLoading(true);
        try {
            const userID = generateTimestampID();

            const doc = {
                _type: "user",
                userID: userID,
                username: newUser.username,
                contactNumber: newUser.contactNumber,
                remarks: newUser.remarks || "",
                createdAt: new Date().toISOString(),
            };

            if (newUser.imageFile) {
                const imageAsset = await client.assets.upload("image", newUser.imageFile);
                doc.image = {
                    _type: "image",
                    asset: { _type: "reference", _ref: imageAsset._id },
                };
            }

            const createdUser = await client.create(doc);

            setNewUser({ username: "", contactNumber: "", remarks: "", imageFile: null });
            onUserCreated(createdUser);
            onClose();
            showToast("success", `User created! ID: ${userID}`);
        } catch (err) {
            console.error("Error creating user:", err);
            showToast("error", "Failed to create user");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="new-user-modal" onClick={onClose}>
            <div className="new-user-content" onClick={(e) => e.stopPropagation()}>
                <div className="new-user-header">
                    <h5 className="new-user-title">Create New User</h5>
                    <button className="new-user-close" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="new-user-body">
                    <form onSubmit={handleCreateUser}>
                        <div className="new-user-group">
                            <label className="new-user-label">
                                Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="new-user-input"
                                value={newUser.username}
                                onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
                                required
                            />
                        </div>

                        <div className="new-user-group">
                            <label className="new-user-label">
                                Contact Number <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="new-user-input"
                                value={newUser.contactNumber}
                                onChange={(e) => setNewUser({ ...newUser, contactNumber: e.target.value })}
                                required
                            />
                        </div>

                        <div className="new-user-group">
                            <label className="new-user-label">Upload Image (Optional)</label>
                            <input
                                type="file"
                                accept="image/*"
                                className="new-user-file"
                                onChange={(e) => setNewUser({ ...newUser, imageFile: e.target.files[0] })}
                            />
                        </div>

                        <div className="new-user-group">
                            <label className="new-user-label">Remarks (Optional)</label>
                            <textarea
                                className="new-user-input"
                                rows="3"
                                value={newUser.remarks}
                                onChange={(e) => setNewUser({ ...newUser, remarks: e.target.value })}
                            />
                        </div>

                        <button type="submit" className="new-user-btn" disabled={loading}>
                            {loading ? "Saving..." : "Save User"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}